export const FILTER_OPERATIONS = {
  EQUALS: 'eq',
  CONTAINS: 'contains',
};
